/* eslint-disable react-hooks/exhaustive-deps */
import React, { ReactElement, useContext, useEffect, useState } from 'react'

import { PageContainer, ButtonWrapper, Button, FullPage } from 'components'
import { TrackEventEnum } from 'interfaces/trackEvent.interface'
import { useHistory } from 'react-router-dom'
import { RoutesEnum } from 'enums/routes.enum'
import { IPosAberturaCtx } from 'interfaces/posAbertura.interface'
import { FichaCadastralCtx, PosAberturaCtx } from 'App'
import { putContaGlobal } from 'services/axios'
import { IFichaCadastralCtx } from 'interfaces/fichaCadastral.interface'
import { sendToNewRelic } from 'services'
import { useTrackEvent } from 'hooks'

import { Text, Carousel, BottomSheet } from '@inter/inter-ui'

import { CarouselWrapper } from './style'
import { contaGlobalLabels, slidersAccountInfo } from './constants'
import { Termos } from './termos'

const ContaGlobal = () => {
  const [openTermsModal, setOpenTermsModal] = useState<boolean>(false)
  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false)
  const [isOpenFeedbackModal, setIsOpenFeedbackModal] = useState<boolean>(false)
  const [bottomSheetContent, setBottomSheetContent] = useState<ReactElement>(<></>)

  const { hsfc }: IFichaCadastralCtx = useContext<IFichaCadastralCtx>(FichaCadastralCtx)
  const { posAberturaOptions, setPosAberturaOptions }: IPosAberturaCtx =
    useContext<IPosAberturaCtx>(PosAberturaCtx)

  const history = useHistory()
  const sendTrackEventData = useTrackEvent()

  const hsfcValue = (): string => hsfc || (sessionStorage.getItem('hsfc') as string)

  const handleClickEntendi = () => {
    sendTrackEventData(TrackEventEnum.GERAL_BOTAO, {
      content_id: contaGlobalLabels.PAGE_NAME,
      content_name: contaGlobalLabels.UNDERSTOOD,
    })
    sendToNewRelic('POS_ABERTURA', TrackEventEnum.GERAL_BOTAO, {
      content_id: contaGlobalLabels.PAGE_NAME,
      content_name: contaGlobalLabels.UNDERSTOOD,
      FICHA_CADASTRAL: hsfcValue(),
    })

    setIsOpenFeedbackModal(false)
    history.push(RoutesEnum.HOME_POS_ABERTURA)
  }

  const handleClickTentarNovamente = () => {
    setIsOpenFeedbackModal(false)
    setOpenTermsModal(true)

    sendToNewRelic('POS_ABERTURA', TrackEventEnum.GERAL_BOTAO, {
      content_id: contaGlobalLabels.PAGE_NAME,
      content_name: contaGlobalLabels.TRY_AGAIN,
      FICHA_CADASTRAL: hsfcValue,
    })
  }

  useEffect(() => {
    putContaGlobal({
      data: {
        criaContaGlobal: false,
        interesseContaGlobal: true,
      },
      header: {
        hsfc: hsfcValue(),
      },
      success: () => {
        sendToNewRelic('POS_ABERTURA', 'Interesse Conta Global - Sucesso', {
          FICHA_CADASTRAL: hsfcValue(),
        })
      },
      error: (error) => {
        sendToNewRelic('POS_ABERTURA', 'Interesse Conta Global - Error', {
          FICHA_CADASTRAL: hsfcValue(),
          response: JSON.stringify(error),
        })
      },
    })
  }, [])

  const successBottomSheet = () => (
    <>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <h3>Solicitação enviada com sucesso</h3>
        <p className="mb-4">
          Em breve você receberá a resposta da análise da sua solicitação por e-mail.
        </p>
      </div>

      <ButtonWrapper>
        <Button type="submit" onClick={handleClickEntendi}>
          {contaGlobalLabels.UNDERSTOOD}
        </Button>
      </ButtonWrapper>
    </>
  )

  const failBottomSheet = () => (
    <>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <h3>Não conseguimos processar sua solicitação</h3>
        <p className="mb-4">Você pode tentar novamente agora ou em alguns instantes.</p>
      </div>

      <ButtonWrapper>
        <Button type="submit" onClick={handleClickTentarNovamente}>
          {contaGlobalLabels.TRY_AGAIN}
        </Button>

        <Button variant="secondary" type="submit" onClick={handleClickAgoraNao}>
          {contaGlobalLabels.NOT_OPEN_ACCOUNT}
        </Button>
      </ButtonWrapper>
    </>
  )

  const handleClickAbrirConta = () => {
    sendTrackEventData(TrackEventEnum.GERAL_BOTAO, {
      content_id: contaGlobalLabels.PAGE_NAME,
      content_name: contaGlobalLabels.OPEN_GLOBAL_ACCOUNT,
    })
    sendToNewRelic('POS_ABERTURA', TrackEventEnum.GERAL_BOTAO, {
      content_id: contaGlobalLabels.PAGE_NAME,
      content_name: contaGlobalLabels.OPEN_GLOBAL_ACCOUNT,
      FICHA_CADASTRAL: hsfcValue(),
    })

    setOpenTermsModal(true)
  }

  const handleClickAgoraNao = () => {
    sendTrackEventData(TrackEventEnum.GERAL_BOTAO, {
      content_id: contaGlobalLabels.PAGE_NAME,
      content_name: contaGlobalLabels.NOT_OPEN_ACCOUNT,
    })
    sendToNewRelic('POS_ABERTURA', TrackEventEnum.GERAL_BOTAO, {
      content_id: contaGlobalLabels.PAGE_NAME,
      content_name: contaGlobalLabels.NOT_OPEN_ACCOUNT,
      FICHA_CADASTRAL: hsfcValue(),
    })

    history.push(RoutesEnum.HOME_POS_ABERTURA)
  }

  const handleChangeCarousel = (_: number, nextSlide: number) => {
    sendTrackEventData(TrackEventEnum.GERAL_SLIDER, {
      content_id: contaGlobalLabels.PAGE_NAME,
      content_name: slidersAccountInfo[nextSlide].title,
    })
    sendToNewRelic('POS_ABERTURA', TrackEventEnum.GERAL_SLIDER, {
      content_id: contaGlobalLabels.PAGE_NAME,
      content_name: slidersAccountInfo[nextSlide].title,
      FICHA_CADASTRAL: hsfcValue(),
    })
  }

  const Slider = () => (
    <>
      <CarouselWrapper>
        <Carousel
          dots
          slidesToShow={1}
          dotsType="big"
          verticalMode={false}
          arrows={false}
          beforeChange={(currentSlide: number, nextSlide: number) =>
            handleChangeCarousel(currentSlide, nextSlide)
          }
        >
          {slidersAccountInfo.map((slide) => (
            <span key={slide.title}>
              <img src={slide.img} alt={slide.title} width="100%" />

              <div style={{ margin: '24px 24px 0' }}>
                <h1>{slide.title}</h1>
                <Text variant="body-3" as="p" style={{ minHeight: '30px' }}>
                  {slide.contents}
                </Text>
              </div>
            </span>
          ))}
        </Carousel>
      </CarouselWrapper>
    </>
  )

  const handleConfirmOpenAccount = () => {
    setLoadingSubmit(true)

    putContaGlobal({
      data: {
        criaContaGlobal: true,
        interesseContaGlobal: false,
      },
      header: {
        hsfc: hsfcValue(),
      },
      success: () => {
        setBottomSheetContent(successBottomSheet)
        setPosAberturaOptions({
          ...posAberturaOptions,
          global: { ...posAberturaOptions.global, done: true },
        })
        sendToNewRelic('POS_ABERTURA', 'ContaGlobal - Sucesso', {
          FICHA_CADASTRAL: hsfcValue(),
        })
      },
      error: () => {
        setOpenTermsModal(false)
        setBottomSheetContent(failBottomSheet)
      },
      finally: () => {
        setIsOpenFeedbackModal(true)
        setLoadingSubmit(false)
      },
    })
  }

  useEffect(() => {
    sendToNewRelic('POS_ABERTURA', '[Screen] - ContaGlobal', {
      FICHA_CADASTRAL: hsfcValue(),
    })
  }, [])

  return (
    <PageContainer>
      <Slider />

      <ButtonWrapper>
        <Button onClick={handleClickAbrirConta}>{contaGlobalLabels.OPEN_GLOBAL_ACCOUNT}</Button>
        <Button variant="secondary" onClick={handleClickAgoraNao}>
          {contaGlobalLabels.NOT_OPEN_ACCOUNT}
        </Button>
      </ButtonWrapper>

      <FullPage activeCloseFullPage={openTermsModal}>
        <Termos
          onConfirmClick={handleConfirmOpenAccount}
          onBackClick={() => setOpenTermsModal(false)}
          loading={loadingSubmit}
          hsfcValue={hsfcValue()}
        />
      </FullPage>

      {isOpenFeedbackModal && (
        <BottomSheet onClose={() => setIsOpenFeedbackModal(false)}>
          {bottomSheetContent}
        </BottomSheet>
      )}
    </PageContainer>
  )
}

export default ContaGlobal
